import {
  CircularProgress as EtCircularProgress,
  ProgressFilter,
} from "@ever-tutor/et-ui";

export type { ProgressFilter };

// Small circular progress indicator for goal completion (0.0 - 1.0)
export const CircularProgress = ({
  value,
  size = 20,
  thickness = 4,
  color = "#F5C744",
  trackColor = "#E5E7EB",
}: {
  value: number; // 0..1
  size?: number;
  thickness?: number;
  color?: string;
  trackColor?: string;
}) => {
  return (
    <EtCircularProgress
      value={value}
      size={size}
      thickness={thickness}
      color={color}
      trackColor={trackColor}
      aria-label={`Progress: ${Math.round(value * 100)}%`}
    />
  );
};
